import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Cipher, State } from '../shared/types';
import { ConfigApiService } from './config-api.service';

import aesjs from 'aes-js';
import forge from 'node-forge';

@Injectable({
  providedIn: 'root'
})
export class PersistanceService {
  private identifier: string = environment.StateIdentifier;

  constructor(
    private http: HttpClient,
    private configApiService: ConfigApiService
  ) {}

  persistState(state: State, commit: boolean, studyFinished: boolean) {
    sessionStorage.setItem(this.identifier, JSON.stringify(state));

    if (commit == true) {
      //transfer results to the backend
      this.transferState(state, studyFinished);
    }
  }

  clearSessionStorage() {
    sessionStorage.clear();
  }

  private transferState(state: State, studyFinished: boolean) {
    try {
      const url = `${environment.backendURL}${environment.endpointStoreResults}`;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };

      const cipher: Cipher = this.encryptState(state);

      const transferObject = {
        userId: this.configApiService.getParams().user,
        projectId: this.configApiService.getParams().project,
        encryptedResults: cipher.encryptedHex,
        encryptedAESkey: cipher.encryptedKey,
        hasFinished: studyFinished
      };

      this.http.post(url, transferObject, httpOptions).subscribe(() => {
        console.log('Results have been sent to the backend');
      });
    } catch (error) {
      console.error('An error occured while transfering the study results to the backend');
      console.error(error);
    }
  }

  private encryptState(state: State): Cipher {
    const key = this.makeid(16); // [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16 ];

    // Convert text to bytes
    const textBytes = aesjs.utils.utf8.toBytes(JSON.stringify(state));

    // The counter is optional, and if omitted will begin at 1
    const aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
    const encryptedBytes = aesCtr.encrypt(textBytes);

    const encryptedKey = this.encryptKey(key.join(','));

    // To print or store the binary data, you may convert it to hex
    const encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);

    return { encryptedHex, encryptedKey };
  }

  //TODO:#type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private makeid(length: number): any {
    // pseudorandom generator for key/IV
    const id = [];
    for (let i = 0; i < length; i++) {
      id.push(Math.floor(Math.random() * 256));
    }
    return id;
  }

  private encryptKey(key: string): string {
    const PUBLIC_KEY = environment.encryptionPublicKey;
    const publicKey = forge.pki.publicKeyFromPem(PUBLIC_KEY);
    const encrypted = publicKey.encrypt(key, 'RSA-OAEP', {
      md: forge.md.sha256.create()
      /*       mgf1: {
        md: forge.md.sha1.create()
      } */
    });
    //publicKey.encrypt(secretMessage);

    const encrypted_key = forge.util.encode64(encrypted);

    return encrypted_key;
  }
}
